import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Button, Card, CardHeader, Container, Row, Spinner } from "reactstrap";
import ListHeader from "components/Headers/ListHeader";
import axiosConfig from "consts/axiosConfig";
import AddEditClientModal from "./AddEditClientModal";
import ShowClientModal from "./ShowClientModal";
import { removeWidgetItem } from "consts/Constants";
import Swal from "sweetalert2";
import OverlayLoader from "consts/OverlayLoader";

const { SearchBar } = Search;

export default function UserClients(props) {
  const [loading, setLoading] = useState(false);
  const [showAddEditModal, setShowAddEditModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState([]);
  const [currentModel, setCurrenModel] = useState({});

  const pagination = paginationFactory({
    page: 1,
    alwaysShowAllBtns: true,
    showTotal: true,
    withFirstAndLast: false,
    sizePerPageRenderer: ({
      options,
      currSizePerPage,
      onSizePerPageChange,
    }) => (
      <div className="dataTables_length" id="datatable-basic_length">
        <label>
          {
            <select
              name="datatable-basic_length"
              aria-controls="datatable-basic"
              className="form-control form-control-sm"
              onChange={(e) => {
                onSizePerPageChange(e.target.value);
              }}
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          }{" "}
          entries.
        </label>
      </div>
    ),
  });

  const getItems = () => {
    setLoading(true);
    axiosConfig
      .get("clients/index")
      .then((res) => {
        setLoading(false);

        setData(res.data.result.clients);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  const removeItem = (id) => {
    removeWidgetItem("clients/delete/" + id, getItems);
  };
  useEffect(() => {
    getItems();
  }, []);
  const newItemModal = () => {
    setCurrenModel({});
    setShowAddEditModal(true);
  };
  return (
    <>
      <ListHeader
        name="Clients"
        parentName="Dashboard"
        setShowModal={newItemModal}
        setCurrenModel={setCurrenModel}
      />
      <Container className="mt--6" fluid>
        {showAddEditModal ? (
          <AddEditClientModal
            showModal={showAddEditModal}
            toggleModal={setShowAddEditModal}
            getClients={getItems}
            currentModel={currentModel}
            url_perfix="clients/"
          />
        ) : (
          <></>
        )}
        <ShowClientModal
          showModal={showModal}
          toggleModal={setShowModal}
          currentModel={currentModel}
          url_perfix="clients/"
        />
        <Row>
          <div className="col">
            <Card>
              <CardHeader>
                <h3 className="mb-0">Clients</h3>
              </CardHeader>
              <ToolkitProvider
                data={data}
                keyField="id"
                columns={[
                  {
                    dataField: "firstname",
                    text: "First Name",
                    sort: true,
                  },
                  {
                    dataField: "lastname",
                    text: "Last Name",
                    sort: true,
                  },
                  {
                    dataField: "address",
                    text: "Address",
                    sort: true,
                  },
                  {
                    dataField: "city",
                    text: "City",
                    sort: true,
                  },
                  {
                    dataField: "state",
                    text: "State",
                    sort: true,
                  },
                  {
                    dataField: "country",
                    text: "Country",
                    sort: true,
                  },
                  {
                    dataField: "name",
                    text: "Actions",
                    editable: true,
                    sort: false,
                    formatter: (cell, row) => {
                      return (
                        <>
                          <Button
                            color="info"
                            size="sm"
                            onClick={() => {
                              setCurrenModel(row);
                              setShowModal(true);
                            }}
                          >
                            <i className="fa fa-eye" />
                          </Button>

                          <Button
                            color="primary"
                            size="sm"
                            onClick={() => {
                              setCurrenModel(row);
                              setShowAddEditModal(true);
                            }}
                          >
                            <i className="fa fa-pen" />
                          </Button>

                          <Button
                            color="danger"
                            size="sm"
                            onClick={() =>
                              Swal.fire({
                                title: "Are you sure?",
                                text: "You won't be able to revert this!",
                                icon: "warning",
                                showCancelButton: true,
                                confirmButtonColor: "#3085d6",
                                cancelButtonColor: "#d33",
                                confirmButtonText: "Yes, delete it!",
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  removeItem(row.id);
                                }
                              })
                            }
                          >
                            <i className="fa fa-trash" />
                          </Button>
                        </>
                      );
                    },
                  },
                ]}
                search
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    <div
                      id="datatable-basic_filter"
                      className="dataTables_filter px-4 pb-1"
                    >
                      <label>
                        Search:
                        <SearchBar
                          className="form-control-sm"
                          placeholder=""
                          {...props.searchProps}
                        />
                      </label>
                    </div>
                    <BootstrapTable
                      {...props.baseProps}
                      bootstrap4={true}
                      pagination={pagination}
                      bordered={false}
                      noDataIndication={
                        loading ? (
                          <Spinner color="info" size="xl" />
                        ) : (
                          <div>
                            <p>No Clients yet!</p>
                            <a
                              className="btn btn-link text-muted font-italic"
                              onClick={() => {
                                setCurrenModel({});
                                setShowAddEditModal(true);
                              }}
                            >
                              Start by adding to your clients
                            </a>
                          </div>
                        )
                      }
                    />
                  </div>
                )}
              </ToolkitProvider>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
}
